import React from 'react';
import SvgIcon from './SvgIcon';

const Favorite = props => (
    <SvgIcon {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-375.000000, -735.000000)" fill="#3777BC" fillRule="nonzero">
                <g transform="translate(375.000000, 735.000000)">
                    <path d="M15.144,5.438 L10.828,4.811 L8.897,0.9 C8.559,0.217 7.441,0.217 7.103,0.9 L5.173,4.811 L0.856,5.438 C0.039,5.557 -0.292,6.565 0.302,7.145 L3.426,10.189 L2.689,14.488 C2.55,15.302 3.406,15.927 4.14,15.542 L8,13.513 L11.861,15.543 C12.589,15.924 13.452,15.309 13.312,14.489 L12.575,10.19 L15.699,7.146 C16.292,6.565 15.961,5.557 15.144,5.438 Z"></path>
                </g>
            </g>
        </g>
    </SvgIcon>
);

Favorite.displayName = 'FavoriteIcon';

export default Favorite;
